module.exports = __webpack_public_path__ + "static/img/contact-qa-red.a7526831.svg";